import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { RouterTypeEffects } from './router-types.effects';
import { routerTypesFeatureKey } from './router-types.models';
import { routerTypes } from './router-types.reducer';

@NgModule({
    imports: [SharedModule, StoreModule.forFeature(routerTypesFeatureKey, routerTypes), EffectsModule.forFeature([RouterTypeEffects])],
    exports: [],
    declarations: [],
    providers: [],
})
export class RouterTypesModule {}
